import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { extensionMainMenuItemsSubject } from '../../index';
import { MenuTypesName } from '../../sdk.types';
import { ExtensionMenuLink } from '../extension-menu-item';
import './main-menu-wrapper.style.scss';
import { ErrorBoundary } from '../error-boundary';
export const MainMenuWrapper = () => {
    const [extensionMenus, setExtensionMenus] = useState(extensionMainMenuItemsSubject.value);
    useEffect(() => {
        const navigationSubscription = extensionMainMenuItemsSubject.subscribe(setExtensionMenus);
        return () => {
            navigationSubscription.unsubscribe();
        };
    }, []);
    if (extensionMenus.length === 0) {
        return null;
    }
    return (<>
      <h2 className="sidebar__title sidebar__title--extensions">
        <FormattedMessage id="account.sidebar.avail-tools.title" defaultMessage="EXTENSIONS"/>
      </h2>
      <div className="main-menu__list main-menu__list--extensions">
        {extensionMenus.map((extensionMenuItem, index) => (<ErrorBoundary key={`${extensionMenuItem.props.key}_${index}`} extensionName={extensionMenuItem.extensionName}>
            <ExtensionMenuLink keyProp={extensionMenuItem.props.key} extensionName={extensionMenuItem.extensionName} menuType={MenuTypesName.MAIN_MENU} {...extensionMenuItem.props}/>
          </ErrorBoundary>))}
      </div>
    </>);
};
